import React from 'react'

import { SecondaryNavLayout } from 'src/modules/ui'

import CustomerAgreementList from './CustomerAgreementList'
import CustomerAgreement from './CustomerAgreement'

const CustomerAgreements = () => {
  const routes = [
    {
      navLabel: 'Proposals',
      path: `/customers/proposals`,
      render: props => (
        <CustomerAgreementList
          {...props}
          section="proposals"
          title="Proposals"
        />
      ),
    },
    {
      navLabel: 'Approved',
      path: `/customers/approved`,
      render: props => (
        <CustomerAgreementList {...props} section="accepted" title="Approved" />
      ),
    },
    {
      path: '/customers/:id/',
      component: CustomerAgreement,
      title: 'Order',
    },
  ]

  return <SecondaryNavLayout routes={routes} />
}
export default CustomerAgreements
